module.exports = __webpack_public_path__ + "media/images/common/kuchi_03-05b4715f6af0afaa43ef70a308c4cdad.gif";